import React, { Component } from 'react';
import { Button } from 'carbon-components-react';
import StepCard from '../../StepCard';
import { parseModelMessage } from '../../../utils/modifiers';

class NoteCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      observacao: (props.data && props.data.observacao) || null,
      salvouObservacao: false,
    };
  }

  componentWillMount = () => {
    const {data} = this.props;
    if(data && data.observacao){
      this.setState({salvouObservacao: true})
    }
  }

  renderDescription = () => {
    const { step, data } = this.props;

    if (data && data.observacao) {
      return (
        <div className="font-size-13" style={{ color: '#36474f' }}>
          <strong>
            {step.form === 'observacao' ? 'Observações' : 'Observações'}
:
          </strong>
          <br />
          <div
            dangerouslySetInnerHTML={{
              __html: parseModelMessage(data.observacao),
            }}
          />
        </div>
      );
    }

    return step.description;
  };

  onChangeText = (event) => {
    this.setState(
      {
        [event.target.id]: event.target.value,
      }
    );
  };

  canSave = () => {
    const { observacao } = this.state;
    
    if (observacao.length >= 3) {
      this.setState({ salvouObservacao: true });
      this.stepCardRef.toggleContent();
    } else {
      return false;
    }
    return undefined;
  };

  save = async () => {
    const { observacao } = this.state;
    const { saveStep /* , selectedValue */ } = this.props;
    await saveStep({
      observacao,
      salvouObservacao: true,
    });
    
    await this.canSave();

    // this.setState({ selectedValue });
  };

  cancel = () => {    
    this.stepCardRef.toggleContent();
  };

  render() {
    const { step, buttonIn, isStore } = this.props;
    const { observacao, salvouObservacao } = this.state;

    return (
      <StepCard
        onRef={(ref) => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={salvouObservacao}
        disabled={isStore}
      >
        <div className="bx--row mg-top-20">
          <div className="bx--col-xs-12">
            <div className="bx--form-item">
              <textarea
                id="observacao"
                className="bx--text-area"
                rows="4"
                cols="50"
                onChange={this.onChangeText}
                defaultValue={observacao || null}
                placeholder="Exemplo: Crescimento de 30% em NC, aumento do ticket médio da loja."
              />
              <label htmlFor="text-area-2" className="bx--label">
                {' '}
                Escreva abaixo as observações:
                {' '}
              </label>
            </div>
          </div>
        </div>
        {buttonIn && (
          <div className="bx--row">
            <div className="bx--col-md-12">
              <br />
              {' '}
              <br />
              <div className="v-md-margin mg-top-40">
                <Button onClick={this.save}>Avançar</Button>
                <Button kind="ghost" className="h-sm-margin" onClick={this.cancel}>
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        )}
      </StepCard>
    );
  }
}

export default NoteCampaign;



// WEBPACK FOOTER //
// ./src/components/trades/campaign/NoteCampaign.js